import React, { Component } from 'react';
import ReactGA from 'react-ga';

// style
import './normalize.css';
import './style.css';

// components
import Section from '../Section';

// images
import appStoreBadge from '../../assets/app-store-badge.svg';
import icon from '../../assets/burst-app-icon.svg';
import info from '../../assets/screenshot/info.jpg';
import replying from '../../assets/screenshot/replying.jpg';
import richComments from '../../assets/screenshot/rich-comments.jpg';
import voting from '../../assets/screenshot/voting.jpg';

// video
import bubblesMp4       from '../../assets/video/bubbles.mp4';
import bubblesWebm      from '../../assets/video/bubbles.webm';
import commentingMp4    from '../../assets/video/commenting.mp4';
import commentingWebm   from '../../assets/video/commenting.webm';
import doggosMp4        from '../../assets/video/doggos.mp4';
import doggosWebm       from '../../assets/video/doggos.webm';
import infoMp4          from '../../assets/video/info.mp4';
import infoWebm         from '../../assets/video/info.webm';
import searchMp4        from '../../assets/video/search.mp4';
import searchWebm       from '../../assets/video/search.webm';
import votingMp4        from '../../assets/video/voting.mp4';
import votingWebm       from '../../assets/video/voting.webm';

class App extends Component {
    componentDidMount = () => {
        ReactGA.initialize('UA-23275703-6', {
            debug: window.location.host.match('localhost') ? true : false
        });
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
            <div>
                <Section hasSlash>
                    <header>
                        <img src={icon} alt="Burst for reddit" className="icon" />
                        <h1>
                            Burst <small>for reddit</small>
                        </h1>
                    </header>
                    <p className="hide-for-mobile">Fake news, echo chambers and unconscious bias.</p>
                    <p>How do you get out of a filter bubble if you don’t even know you’re in one?</p>
                    <a className="badge-link" href="https://itunes.apple.com/us/app/burst-for-reddit/id1303179128?ls=1&mt=8" target="_blank" rel="noopener noreferrer">
                        <img src={appStoreBadge} alt="Download on the App Store" className="badge" />
                    </a>
                    <p className="hide-for-mobile"><a href="https://goo.gl/forms/VnwtU0PuLCjHbOKP2" target="_blank" rel="noopener noreferrer"><span className="small">Android Beta</span></a></p>
                </Section>

                <Section name="doggos" preload video mp4={doggosMp4} webm={doggosWebm}>
                    <h2>All of reddit</h2>
                    <p>For every link in your feed, Burst finds reposts across every subreddit and combines them.</p>
                    <p className="hide-for-mobile">Flick through comments from multiple subreddits without digging around like some kind of crazed animal.</p>
                </Section>

                <Section name="bubbles" video mp4={bubblesMp4} webm={bubblesWebm}>
                    <h2>Burst yo bubble</h2>
                    <p className="hide-for-mobile">In the age of fake news, it's hard to know whether or not you're getting the complete picture of a news story.</p>
                    <p>With comments from liberal, moderate, and conservative subreddits in one place, Burst gives you perspective over every discussion happening on reddit.</p>
                </Section>

                <Section name="rich-comments" image={richComments}>
                    <h2>Rich comments</h2>
                    <p>Images are meant to be seen! Burst loves images and gifs so much, it'll find them in comments to show you a nifty preview.</p>
                </Section>

                <Section name="commenting" image={replying} midPoster video mp4={commentingMp4} webm={commentingWebm}>
                    <h2>Inline commenting</h2>
                    <p>Going places is hard! Burst lets you comment right there so you don't lose your place.</p>
                </Section>

                <Section name="voting" image={voting} video mp4={votingMp4} webm={votingWebm}>
                    <h2>Force touch voting</h2>
                    <p className="hide-for-mobile">Burst's minimalist design gets everything out of the way, even voting buttons!</p>
                    <p>Don't worry about pecking around on some tiny upvote button! Now you can force-touch anywhere to vote on posts and comments.</p>
                </Section>

                <Section name="info" image={info} video mp4={infoMp4} webm={infoWebm}>
                    <h2>Details at a swipe</h2>
                    <p className="hide-for-mobile">Need a little more detail? Burst has everything you need, when you need it.</p>
                    <p>Swipe over on a post to see its score, poster, subreddit and more.</p>
                </Section>

                <Section name="search" video mp4={searchMp4} webm={searchWebm}>
                    <h2>Splendid search</h2>
                    <p className="hide-for-mobile">Looking for something? Burst makes it easy.</p>
                    <p>Find subreddits and submissions in one place with Burst's unified search. See the best of a subreddit with simple filtering controls.</p>
                </Section>

                <Section name="the-end" hasSlash hideImgForMobile>
                    <h2>Let's be friends</h2>
                    <p><a href="https://itunes.apple.com/us/app/burst-for-reddit/id1303179128?ls=1&mt=8" target="_blank" rel="noopener noreferrer">Go get Burst</a> and <a href="https://twitter.com/burstapp_" target="_blank" rel="noopener noreferrer">tell me</a> how much you love it on a scale from 👍 to 🌵</p>
                </Section>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js